import React from 'react'
import { TextProps, TextStyle } from 'react-native'
import { helpers } from '@linqpal/common-frontend'
import { Text } from 'react-native-paper'
import { useResponsive } from '../../utils/hooks'

const { composeStyle } = helpers

type Props = {
  children: React.ReactNode
  style?: TextStyle
  testID?: string
}

export default ({ style, children, testID = 'title', ...rest }: TextProps) => {
  const { sm } = useResponsive()
  return (
    <Text
      style={composeStyle(
        {
          fontFamily: 'Inter, sans-serif',
          fontWeight: '600',
          fontSize: sm ? 32 : 24,
          lineHeight: 39,
          textAlign: sm ? undefined : 'center',
          alignSelf: 'center',
          color: '#003353',
        },
        style,
      )}
      {...rest}
      testID={testID}
    >
      {children}
    </Text>
  )
}

export const SubTitle = ({ style, children, testID = 'subtitle' }: Props) => {
  const { sm } = useResponsive()
  return (
    <Text
      style={composeStyle(
        {
          fontFamily: 'Inter, sans-serif',
          fontSize: sm ? 18 : 15,
          fontWeight: '400',
          color: '#668598',
          lineHeight: sm ? 30 : 24,
          textAlign: sm ? undefined : 'center',
          alignSelf: 'center',
        },
        style,
      )}
      testID={testID}
    >
      {children}
    </Text>
  )
}
